module.exports = __webpack_public_path__ + "static/media/media-min2.f03eae28.jpg";